/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { moleculeLog } from 'utils/logUtil'
import A_FieldCheckBox from '../A_FieldCheckBox'
import M_ButtonNormal from './M_ButtonNormal'

type Props = {
  label: string
  check1: boolean
  check2: boolean
  check3: boolean
  check4: boolean
  event1: (e: React.ChangeEvent<HTMLInputElement>) => void
  event2: (e: React.ChangeEvent<HTMLInputElement>) => void
  event3: (e: React.ChangeEvent<HTMLInputElement>) => void
  event4: (e: React.ChangeEvent<HTMLInputElement>) => void
  buttonLabel: string
  buttonEvent: () => void
  disabled?: boolean
}

const useStyles = makeStyles(() =>
  createStyles({
    item: {
      border: '1px solid #000000',
      padding: 2,
    },
    noBorderItem: {
      padding: 2,
      paddingLeft: 4,
    },
  }),
)

const M_FieldJuryoMobile = ({ label, check1, check2, check3, check4, event1, event2, event3, event4, buttonLabel, buttonEvent, disabled = false }: Props) => {
  useEffect(() => moleculeLog('M_FieldJuryoMobile'))
  const classes = useStyles()
  return (
    <Grid container justifyContent="flex-start">
      <Grid item xs={3}>
        <Typography variant="body1" display="block" gutterBottom>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={4} className={classes.item}>
        <div>
          <A_FieldCheckBox label="未受領" check={check1} change={event1} disabled={disabled} position="end" />
          <br />
          <A_FieldCheckBox label="受領済" check={check2} change={event2} disabled={disabled} position="end" />
          <br />
          <A_FieldCheckBox label="確認依頼" check={check3} change={event3} disabled={disabled} position="end" />
        </div>
      </Grid>
      <Grid item xs={5}>
        <Grid item xs={12} className={classes.noBorderItem}>
          <A_FieldCheckBox label="欠品" check={check4} change={event4} disabled={disabled} position="end" color={'secondary'} />
        </Grid>
        <Grid item xs={12} className={classes.noBorderItem}>
          <M_ButtonNormal label={buttonLabel} event={buttonEvent} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default React.memo(M_FieldJuryoMobile)
